"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var locale = {
    alert: {
        close: 'Close',
    },
    calendar: {
        nextMonth: 'Next month',
        previousMonth: 'Previous month',
        nextYear: 'Next year',
        previousYear: 'Previous year',
    },
    dateInput: {
        placeholder: 'mm/dd/yyyy',
    },
    formControl: {
        required: 'Required field',
    },
    input: {
        clear: 'Clear',
    },
    modal: {
        close: 'Close',
    },
    monthPaginator: {
        close: 'Close',
        show: 'Show months',
    },
    paginator: {
        of: 'of',
        previousPage: 'Previous page',
        nextPage: 'Next page',
        currentPage: 'Current page',
    },
    dateRangeField: {
        separator: 'until',
    },
    select: {
        createItem: 'Select an item or type a new value',
        emptyItem: 'No results were found',
        loadingItem: 'Loading...',
        removeItem: 'Remove',
    },
    tableFooter: {
        results: {
            zero: 'results',
            one: 'result',
            other: 'results',
        },
    },
};
exports.default = locale;
//# sourceMappingURL=en-US.js.map